/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zipcity1Inputs */

const de__field_zipcity1 = /** @type {(inputs: _Field_Zipcity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLZ & Stadt`)
};

/**

* @param {_Field_Zipcity1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zipcity1 = /** @type {((inputs?: _Field_Zipcity1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zipcity1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zipcity1(inputs)
});
export { _field_zipcity1 as "_field_zipCity" }